import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTS from "../../../globals/common_utilities/constant";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";

const initialState = {
  loading: false,
  trainingResponse: [],
  error: "",
};

export const Training = createAsyncThunk(
  "training/api",
  ({ token, trainingParams }) => {
    return api_call(
      CONSTANTS.API_METHODS.GET,
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.TRAINING,
      trainingParams,
      {},
      {}
    );
  }
);

const trainingSlice = createSlice({
  name: "training",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(Training.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Training.fulfilled, (state, action) => {
      state.loading = false;
      state.trainingResponse = action.payload;
      state.error = "";
    });
    builder.addCase(Training.rejected, (state, action) => {
      state.loading = false;
      state.trainingResponse = [];
      state.error = action.error.message;
    });
  },
});

export const TrainingData = {
  Training_List: trainingSlice.reducer,
};
